<template>
  <!-- 作者信息 -->
  <div id="app-author-body">
    <!-- 基本信息体 -->
    <div class="app-author-info-body">
      <!-- 头像 -->
      <img class="app-author-img" alt="pic" :src="authorInfo.avatar"/>
      <div class="app-author-name">
        <!-- 用户名 -->
        <p>{{ authorInfo.account }}</p>
        <!-- 用户签名 -->
        <p class="app-author-sign">{{ authorInfo.autograph }}</p>
      </div>
    </div>
    <!-- 推荐内容 -->
    <div class="app-author-recommend">
      <!-- 推荐列表 -->
      <ul>
        <li v-for="item in recommendData" :key="item.id" style="counter-reset:sec;">
          <p class="app-author-recommend-text" v-on:click="openClass(item.id)">
            <span class="aar-icon">▶</span>{{ item.name }}
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import AxiosBase from "@/components/axiosBase";

export default {
  name: "Author",
  props: {
    authorInfo: Object
  },
  data() {
    return {
      recommendData: [],
    }
  },
  beforeMount() {
    AxiosBase.axiosGet("/curriculum/recommend", {
      params: {
        count: 5
      }
    }).then(response => {
      if (response !== 0) {
        this.recommendData = response.data;
      }
    })
  },
  methods: {
    openClass(id) {
      this.$router.push("/article/" + id)
      // window.open(this.$router.resolve("/article/" + id).href)
    }
  },
}
</script>

<style scoped>

#app-author-body {
  width: 100%;
  height: 300px;
  background: rgb(251, 251, 251);
  text-align: center;
  margin-bottom: 15px;
}

.app-author-info-body {
  position: relative;
  width: 300px;
  height: 145px;
  margin: auto;
  border-bottom: 1px solid rgba(20, 20, 20, 0.2);
}

.app-author-img {
  position: absolute;
  border-radius: 48px;
  width: 96px;
  height: 96px;
  left: 5px;
  top: 25px;
}

.app-author-name {
  position: absolute;
  left: 115px;
  right: 0;
  top: 30px;
  font-weight: bold;
  font-size: 20px;
  text-align: left;
}

.app-author-sign {
  color: rgba(20, 20, 20, 0.6);
  margin-top: 5px;
  font-size: 14px;
  font-weight: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}

.app-author-recommend {
  position: relative;
  margin: auto;
  padding: 5px 10px 5px 5px;
  text-align: left;
}

.app-author-recommend-text {
  display: inline-block;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 25px;
  line-height: 30px;
  cursor: pointer;
  font-size: 15px;
}

</style>